module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p data-info="notifications-info">'+
((__t=(i18n.tc('ControlNotifications', 'From the alert list you can read the alert type of each event, and get detailed information on each alert. Press the red garbage bin button to delete alerts from the list.')))==null?'':__t)+
'</p><div class="align-right"><button class="danger" type="button" data-click="delete-all">'+
((__t=(i18n.tc('ControlNotifications', 'Delete all')))==null?'':__t)+
'</button></div><div data-region="notifications-container"></div>';
}
return __p;
};
